import styled from '@emotion/styled';
import { styledOptions } from '@styles/utils';

export const WeatherPrevisionsContainer = styled('div', styledOptions)<{ $vertical?: boolean }>`
  display: grid;
  grid-template-columns: ${props =>
    props.$vertical ? 'repeat(3, 1fr)' : 'repeat(3, 11%) repeat(auto-fit, minmax(0, 1fr))'};
  grid-gap: 20px 10px;
`;
